import {
  customSelectStyles,
  selectTheme,
} from '@plone/volto/components/manage/Blocks/Search/components/SelectStyling';
import {
  selectFacetSchemaEnhancer,
  selectFacetStateToValue,
  selectFacetValueToQuery,
} from '@plone/volto/components/manage/Blocks/Search/components/base';
import {
  DropdownIndicator,
  MultiValueContainer,
  Option,
} from '@plone/volto/components/manage/Widgets/SelectStyling';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import React from 'react';
import { isTagField } from './tagWhitelistEnhancer';

const filterChoicesByWhitelist = (choices, whitelist) => {
  if (!whitelist) {
    return choices;
  }

  let whitelistArray = whitelist;

  // Handle base64-encoded data (convert to array)
  if (typeof whitelist === 'string') {
    try {
      // Try to decode base64 first
      const decoded = atob(whitelist);
      // If decoded string contains multiple values, split them
      whitelistArray = decoded.includes(',') ? decoded.split(',') : [decoded];
    } catch (e) {
      // If not valid base64, treat as single string value
      whitelistArray = [whitelist];
    }
  }

  // Handle array format
  if (!Array.isArray(whitelistArray)) {
    whitelistArray = [whitelistArray];
  }

  if (whitelistArray.length === 0) {
    return choices;
  }

  return choices.filter((choice) => whitelistArray.includes(choice.value));
};

const WhitelistSelectFacet = (props) => {
  const { facet, choices, reactSelect, isMulti, onChange, value, isEditMode } =
    props;
  const Select = reactSelect.default;

  const filteredChoices = isTagField(facet?.field?.value)
    ? filterChoicesByWhitelist(choices, facet.tagWhitelist)
    : choices;

  const v = Array.isArray(value) && value.length === 0 ? null : value;

  return (
    <Select
      placeholder={facet?.title ?? (facet?.field?.label || 'select...')}
      className="react-select-container"
      classNamePrefix="react-select"
      options={filteredChoices}
      styles={customSelectStyles}
      theme={selectTheme}
      components={{ DropdownIndicator, Option, MultiValueContainer }}
      isDisabled={isEditMode}
      onChange={(data) => {
        if (data) {
          onChange(
            facet.field.value,
            isMulti ? data.map(({ value }) => value) : data.value,
          );
        } else {
          // data has been removed
          onChange(facet.field.value, isMulti ? [] : '');
        }
      }}
      isMulti={facet.multiple}
      isClearable
      value={v}
    />
  );
};

// Attach the static properties - use original schema enhancer since we handle tagWhitelist in shadow schema
WhitelistSelectFacet.schemaEnhancer = selectFacetSchemaEnhancer;
WhitelistSelectFacet.stateToValue = selectFacetStateToValue;
WhitelistSelectFacet.valueToQuery = selectFacetValueToQuery;

export default injectLazyLibs('reactSelect')(WhitelistSelectFacet);
